import React, { useEffect, useState } from "react";
import { BlockPicker } from "react-color";

type ColorPickerProps = {
  name: string;
  defaultColor?: string;
  onChange: Function;
  className?: string;
};
const DEFAULT_COLOR = "#424242";

export default function ColorPicker({
  name,
  defaultColor,
  onChange,
  className,
}: ColorPickerProps) {
  const [value, setValue] = useState(defaultColor || DEFAULT_COLOR);
  const [showPicker, pickerVisibility] = useState(false);
  const useStorage = name && typeof window.localStorage !== "undefined";

  useEffect(() => {
    if (useStorage) {
      let v =
        localStorage.getItem(name as string) || defaultColor || DEFAULT_COLOR;
      setValue(v);
      onChange(v);
    } else {
      onChange(value);
    }
  }, []);

  return (
    <div
      className={`color-picker ${className ? className : ""}`}
      style={{ backgroundColor: value }}
      onClick={() => (!showPicker ? pickerVisibility(true) : null)}
    >
      {showPicker && (
        <div className="abs" style={{ top: "30px", left: "-10px" }}>
          <BlockPicker
            color={value}
            triangle="top"
            onChange={(color) => {
              if (useStorage) {
                localStorage.setItem(name as string, color.hex);
              }
              setValue(color.hex);
              pickerVisibility(false);
              onChange(color.hex);
            }}
            colors={[
              "#000000",
              "#FFFFFF",
              "#999999",
              "#82DD7D",
              "#38241D",
              "#C6B0A5",
              "#D2450C",
              "#E8D508",
              "#1199F2",
              "#2D403C",
            ]}
          />
        </div>
      )}
    </div>
  );
}
